import { ILocalStorageService } from 'angular-local-storage';
import { View } from 'app/shared/collections/view';
import { Component, StoredMapOptions } from 'app/shared/map_options/InitialMapOptionsAsset';
import { MapOption } from 'app/shared/map_options/MapOptionsService';

export interface ReturnedSelectedMapOptions {
    defaultSelectedMapOptions: { [key: string]: string };
    selectedMapOptions: { [key: string]: string };
}

export abstract class InitialMapOptionsSetter {
    protected _localStorageService: ILocalStorageService;
    protected _panelKey: string;
    protected _availableMapOptions: { [key: string]: MapOption };
    protected _view: View;

    protected constructor(localStorageService: ILocalStorageService, panelKey: string, view: View) {
        this._localStorageService = localStorageService;
        this._panelKey = panelKey;
        this._view = view;
    }

    public getNewDefaultMapOptions(
        availableMapOptions: { [key: string]: MapOption },
        defaultMapOptions: { [key: string]: string },
    ): ReturnedSelectedMapOptions {
        this._availableMapOptions = availableMapOptions;
        const { defaultSelectedMapOptions, selectedMapOptions } =
            this._getInitialDefaultMapOptions(defaultMapOptions);
        return { defaultSelectedMapOptions, selectedMapOptions };
    }

    protected abstract _getInitialDefaultMapOptions(defaultMapOptions: {
        [key: string]: string;
    }): ReturnedSelectedMapOptions;

    protected _getDefaultsFromLocalStorage(): StoredMapOptions {
        const allMapOptions = this._localStorageService.get(this._panelKey);
        if (allMapOptions && allMapOptions[this._view.name]) {
            return allMapOptions[this._view.name];
        } else {
            return {};
        }
    }

    protected _getDefaultsFromViewComponent(): { [key: string]: string } {
        let defaultMapOptions = {};
        if (this._view.components) {
            const defaultComponent = this._view.defaultOptionConfig;
            if (defaultComponent) {
                defaultMapOptions = this._setDefaultMapOptionForComponent(defaultComponent);
            }
        }
        return defaultMapOptions;
    }

    protected _setDefaultMapOptionForComponent(component: Component): { [key: string]: string } {
        const defaults = {};
        component.config.forEach((defaultOption) => {
            defaults[defaultOption.key] = this._getDefaultMapOptionValue(defaultOption);
        });
        return defaults;
    }

    protected _getDefaultMapOptionValue(defaultOption: {
        key: string;
        value: string;
        panelKey: string;
    }): string {
        if (this._panelKey === defaultOption.panelKey) {
            if (Object.keys(this._availableMapOptions).includes(defaultOption.key)) {
                return defaultOption.value;
            } else {
                throw new Error(
                    'the following key does not exist in availableMapOptions: ' + defaultOption.key,
                );
            }
        }
        return undefined;
    }
}
